import moment from "moment";
import { FILTER_OPERATORS } from "../../../utils/constants";

interface FileSizeFormatResult {
  format: any;
  minDisplayValue: number | null;
  maxDisplayValue: number | null;
  fileSize: { min: number | undefined; max: number | undefined };
}

export function parseFileSizeConditions(
  conditions: Record<string, number | undefined>,
  selectOptions: any[]
): FileSizeFormatResult {
  const minBytes = conditions['$gte'];
  const maxBytes = conditions['$lte'];

  // Default to MB
  let format = selectOptions[1];

  let minDisplayValue: number | null = null;
  let maxDisplayValue: number | null = null;

  const isInGB =
    minBytes !== undefined &&
    maxBytes !== undefined &&
    minBytes % (1024 * 1024 * 1024) === 0 &&
    maxBytes % (1024 * 1024 * 1024) === 0;

  const isInMB =
    minBytes !== undefined &&
    maxBytes !== undefined &&
    minBytes % (1024 * 1024) === 0 &&
    maxBytes % (1024 * 1024) === 0 &&
    !isInGB;

  const isInKB =
    (minBytes !== undefined && minBytes % 1024 === 0 && minBytes % (1024 * 1024) !== 0) ||
    (maxBytes !== undefined && maxBytes % 1024 === 0 && maxBytes % (1024 * 1024) !== 0);

  const isInBytes = !isInGB && !isInMB && !isInKB;

  if (isInGB) {
    format = selectOptions[2]; // GB
    minDisplayValue = minBytes! / (1024 * 1024 * 1024);
    maxDisplayValue = maxBytes! / (1024 * 1024 * 1024);
  } else if (isInMB) {
    format = selectOptions[1]; // MB
    minDisplayValue = minBytes! / (1024 * 1024);
    maxDisplayValue = maxBytes! / (1024 * 1024);
  } else if (isInKB) {
    format = selectOptions[0]; // KB
    minDisplayValue = minBytes! / 1024;
    maxDisplayValue = maxBytes! / 1024;
  } else if (isInBytes) {
    minDisplayValue = minBytes ?? null;
    maxDisplayValue = maxBytes ?? null;
  }

  return {
    format,
    minDisplayValue,
    maxDisplayValue,
    fileSize: {
      min: minBytes,
      max: maxBytes,
    },
  };
}


export const parseCreatedAtConditions = (conditions) => {
  const startDateCondition = conditions[FILTER_OPERATORS.GREATER_THAN_OR_EQUAL];
  const endDateCondition = conditions[FILTER_OPERATORS.LESS_THAN_OR_EQUAL];

  const startDateTemp = startDateCondition
    ? moment(startDateCondition).format('MM-DD-YYYY')
    : '';
  const endDateTemp = endDateCondition
    ? moment(endDateCondition).format('MM-DD-YYYY')
    : '';

  return {
    startDateTemp,
    endDateTemp,
  };
};

export const parseUpdatedAtConditions = (conditions) => {
  const startDateCondition = conditions[FILTER_OPERATORS.GREATER_THAN_OR_EQUAL];
  const endDateCondition = conditions[FILTER_OPERATORS.LESS_THAN_OR_EQUAL];

  const startDateTemp = startDateCondition
    ? moment(startDateCondition).format('MM-DD-YYYY')
    : '';
  const endDateTemp = endDateCondition
    ? moment(endDateCondition).format('MM-DD-YYYY')
    : '';

  return {
    startDateTemp,
    endDateTemp,
  };
};